import { render, staticRenderFns } from "./suchergebnis.vue?vue&type=template&id=3492c99a&scoped=true&"
import script from "./suchergebnis.vue?vue&type=script&lang=js&"
export * from "./suchergebnis.vue?vue&type=script&lang=js&"
import style0 from "./suchergebnis.vue?vue&type=style&index=0&id=3492c99a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3492c99a",
  null
  
)

export default component.exports